<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2">
            <label >门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label >商品:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.nameMix"></lk-input>
          </div>
          <div class="queryItem">
            <label >销售日期:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.saleTime"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label >票折日期:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.rebateTime"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div style="margin-bottom:16px;">
          <DownloadButton  @on-click="download" v-if="handlePermission('profitToatalAnalysisDownLoad')"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
import finance from '../../services/finance';

export default {
  name: 'profitToatalAnalysis',
  components: {
    QueryFrame,
    DownloadButton,
  },
  mixins: [mapState, queryMixins],
  data() {
    return {
      count: 0,
      page: 1,
      query: {
        storeIdList: [],
        nameMix: '',
        saleTime: [1656633600000, new Date().getTime()],
        rebateTime: [1656633600000, new Date().getTime()],
      },
      tableData: [],
      columns: [
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '供应商', key: 'supplierName', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 174 },
        { title: '单位', key: 'drugMinimumPackagingUnit', minWidth: 116 },
        { title: '标准毛利率', key: 'rateStr', minWidth: 116 },
        { title: '实际毛利率', key: 'realGrossProfitRate', minWidth: 116 },
        { title: '是否计提', key: 'isProvisionStr', minWidth: 116 },
        { title: '销售数量', key: 'saleNum', minWidth: 116 },
        { title: '平均售价', key: 'salePriceWithOutTax', minWidth: 116 },
        { title: '期望-实际毛利差额(不含税)', key: 'expectAndRealDiff', minWidth: 116 },
        { title: '门店营销成本(不含税)', key: 'marketingCost', minWidth: 116 },
        { title: '预估总票折(不含税)', key: 'expectTotalRebateAmount', minWidth: 116 },
        { title: '已录入发票票折(不含税)', key: 'payableRebateAmount', minWidth: 116 },
        { title: '已录入其他回款(不含税)', key: 'otherRebateAmount', minWidth: 116 },
        { title: '待回款票折金额(不含税)', key: 'diffRebateAmount', minWidth: 116 },
        {
          title: '操作',
          width: 116,
          fixed: 'right',
          render: (h, params) => (this.handlePermission('profitToatalAnalysisCheck') ? h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on: {
              click: () => {
                this.$router.push({
                  name: 'profitToatalAnalysisCheck',
                  query: {
                    goodsStoreId: params.row.goodsStoreId,
                    supplierStoreId: params.row.supplierStoreId,
                    saleTime: this.query.saleTime,
                    rebateTime: this.query.rebateTime,
                  },
                });
              },
            },
          }, '查看明细') : ''),
        },
      ],
    };
  },
  methods: {
    clear() {
      this.query = {
        storeIdList: [],
        nameMix: '',
        saleTime: [1656633600000, new Date().getTime()],
        rebateTime: [1656633600000, new Date().getTime()],
      };
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      this.formatDateArg(params);
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      finance.downloadRetProfitAnaList(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    formatDateArg(params) { // 需要将日期分开传给后端
      if (params.saleTime && params.saleTime.length) {
        params.saleTimeStart = params.saleTime[0];
        params.saleTimeEnd = params.saleTime[1];
      }
      if (params.rebateTime && params.rebateTime.length) {
        params.rebateTimeStart = params.rebateTime[0];
        params.rebateTimeEnd = params.rebateTime[1];
      }
    },
    getData() {
      this.params = Object.assign({}, this.query);
      this.params.page = this.page;
      this.params.size = this.size;
      this.formatDateArg(this.params);
      finance.getRetProfitAnaList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>

</style>
